export default function CompanyOverview() {
  const values = [
    {
      icon: 'ri-stack-line',
      title: '원스톱 솔루션',
      description: '기획부터 납품 통합 서비스'
    },
    {
      icon: 'ri-shield-check-line',
      title: '품질 중심',
      description: '체계적인 품질 관리 시스템'
    },
    {
      icon: 'ri-links-line',
      title: '통합 생산 체계',
      description: '화장품과 덴탈케어 제품'
    }
  ];

  return (
    <section id="company" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="lg:col-span-7">
            <p className="text-xs font-semibold text-amber-700 tracking-widest uppercase mb-4">
              ABOUT GLORIVE
            </p>
            
            <h2 className="font-serif text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-8">
              신뢰와 품질로<br />
              만들어가는<br />
              파트너십
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="space-y-4">
                <p className="text-base text-gray-700 leading-relaxed">
                  주식회사 글로리브는 화장품 OEM/ODM 전문 기업으로, 브랜드의 기획 단계부터 제품 개발, 생산, 납품까지 원스톱 솔루션을 제공하는 파트너입니다.
                </p>
                <p className="text-base text-gray-700 leading-relaxed">
                  국내 우수 제조 인프라와 협력 네트워크를 기반으로 스킨케어, 바디케어, 기능성 화장품 등 다양한 제품을 안정적으로 생산하고 있습니다.
                </p>
              </div>
              <div className="space-y-4">
                <p className="text-base text-gray-700 leading-relaxed">
                  품질 중심의 제조 시스템과 체계적인 개발 프로세스를 통해 고객사의 브랜드 경쟁력을 강화하고 있습니다.
                </p>
                <p className="text-base text-gray-700 leading-relaxed">
                  글로리브는 고객의 브랜드 가치를 최우선으로 생각하며, 신뢰와 품질을 기반으로 지속 가능한 파트너십을 만들어가고 있습니다.
                </p>
              </div>
            </div>

            {/* Value Cards */}
            <div className="grid md:grid-cols-3 gap-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="p-6 bg-gray-50 rounded-lg hover:bg-amber-50 transition-colors duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${value.icon} text-3xl text-amber-700`}></i>
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">
                    {value.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/a837c703dee398c9a81adf574fadf49b.jpg"
                  alt="Company"
                  className="w-full h-full object-cover object-top"
                />
                
                {/* Stats Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900/90 to-transparent p-8">
                  <div className="grid grid-cols-2 gap-6 text-center">
                    <div>
                      <div className="text-xs text-gray-300">설립연도</div>
                    </div>
                    <div>
                      <div className="text-3xl font-bold text-white mb-1">50+</div>
                      <div className="text-xs text-gray-300">파트너사</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
